import { getSentryClient } from '../sentry';

type LegacyErrorProps = {
	error: unknown;
	functionName: string;
	traceId?: string | null;
};

/** Retains the original transport and payload during the structured logger rollout. */
export const logLegacyError = async ({
	error,
	functionName,
	traceId,
}: LegacyErrorProps): Promise<void> => {
	try {
		const SentryClient = await getSentryClient();
		if (!SentryClient) {
			return;
		}
		SentryClient.withScope((scope) => {
			scope.setTag('packageName', '@atlassian/search-ai');
			scope.setFingerprint([`functionName: ${functionName}`]);
			if (traceId) {
				scope.setTag('traceId', traceId);
			}
			SentryClient.captureException(error, scope);
		});
	} catch (error) {
		// eslint-disable-next-line no-console
		console.error(error);
	}
};
